import { cAPI } from '../../../utils/cAPI';
import { getData } from '../generic';

export const getGroups = searchConfig => dispatch => getData(dispatch, cAPI.APGetGroups, searchConfig, 'groups');